/* eslint-disable no-shadow */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Route, BrowserRouter, Redirect, Switch, Link } from 'react-router-dom';
import { Container, Image, Menu, Button, Popup } from 'semantic-ui-react';

import './App.css';
import Login from './screens/Login';
import Register from './screens/Register';
// import Dashboard from './screens/protected/Dashboard';
import Recipients from './screens/protected/Recipients';
import AccessManagement from './screens/protected/AccessManagement';
import Themes from './screens/protected/Themes';
import Citizenly from './screens/protected/Citizenly';
import Elected from './screens/protected/Elected';
import { e404 } from './screens/Errors';
import {
  AlertBox,
  ConfirmBox,
  setAlertMsg,
  askConfirmation,
} from './components/Modals';
import { MenuLinkItem } from './components/Menu';
import { logout } from './helpers/auth';
import { getUserDisplayNameFromEmail } from './helpers/format';
import { firebaseAuth, firebaseDb, isDemo } from './config/constants';

const PrivateRoute = ({
  component: Component,
  authed,
  habilitations,
  ...rest
}) => (
  <Route
    {...rest}
    render={props =>
      (authed === true ? (
        <Component habilitations={habilitations} {...props} />
      ) : (
        <Redirect
          to={{ pathname: '/login', state: { from: props.location } }}
        />
      ))
    }
  />
);

PrivateRoute.propTypes = {
  component: PropTypes.func.isRequired,
  authed: PropTypes.bool.isRequired,
  habilitations: PropTypes.object,
  // eslint-disable-next-line react/require-default-props
  location: PropTypes.object,
};

PrivateRoute.defaultProps = {
  habilitations: null,
};

// eslint-disable-next-line no-shadow
const PublicRoute = ({ component: Component, authed, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      (authed === false ? <Component {...props} /> : <Redirect to="/" />)
    }
  />
);

PublicRoute.propTypes = {
  component: PropTypes.func.isRequired,
  authed: PropTypes.bool.isRequired,
};

export default class App extends Component {
  state = {
    authed: false,
    loading: true,
  };

  componentDidMount() {
    // console.log('component did mount')
    this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
      // console.log(user);
      if (user && user.email != null) {
        const emailAddress = user.email;
        if (!user.emailVerified) {
          console.log('email not verified')
          return this.setState(askConfirmation(
            'Adresse email non vérifiée',
            `Nous devons vérifier que vous êtes bien le propriétaire de l'adresse email <em>${emailAddress}</em> avant de vous autoriser l'accès à cette interface.<br/>
Pour cela, un <strong><span style="color:#e20000;">lien d'activation vous a été envoyé par email</span></strong>.<br/><br/>
<strong>Votre compte ne sera activé qu'après avoir cliqué sur ce lien</strong>.<br/>
Si vous ne l'avez pas reçu après plusieurs minutes, cliquez sur "Renvoyer le lien".`,
            'warn',
            (confirmed) => {
              if (!confirmed) {
                return firebaseAuth().signOut();
              }
              return user
                .sendEmailVerification()
                .then(() => {
                  this.setState(setAlertMsg(
                    null,
                    'Email envoyé',
                    `Un nouveau lien d'activation a été envoyé à l'adresse' +
              ' <em>${emailAddress}</em>`,
                    'success',
                  ));
                  return firebaseAuth().signOut();
                })
                .catch((error) => {
                  const errorCode = error.code;
                  this.setState(setAlertMsg(errorCode, 'Envoi impossible'));
                  return firebaseAuth().signOut();
                });
            },
            'Renvoyer le lien',
          ));
        }
        firebaseDb()
          .ref(`/administrateurs/${user.uid}`)
          .once('value')
          .then((snapshot) => {
            const admProfile = snapshot.val();
            // console.log(admProfile);
            if (
              admProfile &&
              admProfile.email != null &&
              admProfile.email === user.email
            ) {
              if (admProfile.habilitations && !!admProfile.habilitations) {
                return this.setState({
                  authed: true,
                  loading: false,
                  // eslint-disable-next-line react/no-unused-state
                  habilitations: {
                    ...admProfile.habilitations,
                    uid: user.uid,
                    email: user.email,
                    username: getUserDisplayNameFromEmail(user.email),
                  },
                });
              }
            }
            this.setState(setAlertMsg(
              null,
              'Accès interdit',
              "Ce compte ne dispose d'aucun accès",
              'error',
            ));
            return firebaseAuth().signOut();
          })
          .catch((error) => {
            const errorCode = error.code;
            if (errorCode === 'PERMISSION_DENIED') {
              this.setState(setAlertMsg(
                null,
                'Accès interdit',
                "Ce compte ne dispose d'aucun accès",
                'error',
              ));
            } else {
              this.setState(setAlertMsg(errorCode, 'Accès interdit'));
            }
            return firebaseAuth().signOut();
          });
      } else {
        return this.setState({
          authed: false,
          loading: false,
        });
      }
      return true;
    });
  }

  componentWillUnmount() {
    this.removeListener();
  }

  render() {
    let homeRoute = '/themes';
    const { authed, habilitations } = this.state;
    if (habilitations && !habilitations.superuser && !!habilitations.themes) {
      homeRoute = '/themes';
    } else if (
      habilitations &&
      !habilitations.superuser &&
      !!habilitations.citizenly
    ) {
      homeRoute = '/citizenly';
    } else if (
      habilitations &&
      !habilitations.superuser &&
      !!habilitations.elected
    ) {
      homeRoute = '/elected';
    }

    // console.log(authed ? 'authentifié' : 'non authentifié', 'habilitations :', this.state);
    return this.state.loading === true ? (
      <div id="loading" className="loading-screen">
        Loading
      </div>
    ) : (
      <BrowserRouter>
        <Container className="App">
          {authed && !!habilitations ? (
            <Menu fixed="top" inverted color="black">
              <Menu.Item header>
                <Image
                  size="mini"
                  src="/images/web-logo.svg"
                  style={{ marginRight: '1.5em' }}
                />
                <Link to="/">ViGie ÉMETTEUR</Link>
                {isDemo ? (
                  <span
                    style={{
                      textAlign: 'center',
                      padding: 5,
                      backgroundColor: 'red',
                      marginLeft: 5,
                      color: 'white',
                    }}
                  >
                    DEMO
                  </span>
                ) : null}
              </Menu.Item>
              <MenuLinkItem
                to="/themes"
                activeOnlyWhenExact={false}
                label="Alertes Pro"
                otherCondition={
                  !!habilitations.themes || !!habilitations.superuser
                }
              />
              <MenuLinkItem
                to="/citizenly"
                activeOnlyWhenExact={false}
                label="Participation Citoyenne"
                otherCondition={
                  !!habilitations.citizenly || !!habilitations.superuser
                }
              />
              <MenuLinkItem
                to="/elected"
                activeOnlyWhenExact={false}
                label="Contact Élus"
                otherCondition={
                  !!habilitations.elected || !!habilitations.superuser
                }
              />
              <MenuLinkItem
                to="/recipients"
                activeOnlyWhenExact={false}
                label="Gestion des Destinataires"
              />
              <MenuLinkItem
                to="/access-mgt"
                label="Gestion des Administrateurs"
                activeOnlyWhenExact={false}
                otherCondition={!!habilitations.superuser}
              />
              <Menu.Item position="right">
                <Popup
                  trigger={
                    <Button
                      onClick={() => {
                        logout();
                      }}
                      icon="log out"
                      inverted
                      basic
                      circular
                    />
                  }
                  header={habilitations.username}
                  content="Déconnexion"
                />
              </Menu.Item>
            </Menu>
          ) : null}
          <Container
            className="App"
            style={authed ? { paddingTop: '6em' } : null}
          >
            <Switch>
              <PublicRoute authed={authed} path="/login" component={Login} />
              <PublicRoute
                authed={authed}
                path="/register"
                component={Register}
              />
              <PrivateRoute
                authed={authed}
                habilitations={habilitations}
                path="/themes"
                component={Themes}
              />
              <PrivateRoute
                authed={authed}
                habilitations={habilitations}
                path="/citizenly"
                component={Citizenly}
              />
              <PrivateRoute
                authed={authed}
                habilitations={habilitations}
                path="/elected"
                component={Elected}
              />
              <PrivateRoute
                authed={authed}
                habilitations={habilitations}
                path="/recipients"
                component={Recipients}
              />
              <PrivateRoute
                authed={authed}
                habilitations={habilitations}
                path="/access-mgt"
                component={AccessManagement}
              />
              <Redirect exact from="/" to={homeRoute} />
              <Route component={e404} />
            </Switch>
          </Container>
          <AlertBox
            propagateClosure={() => this.setState({ alert: { open: false } })}
            {...this.state.alert}
          />
          <Switch>
            <Route path="/register" render={() => null} exact />
            <Route
              path="/"
              render={() => (
                <ConfirmBox
                  propagateClosure={() =>
                    this.setState({ confirm: { open: false } })
                  }
                  {...this.state.confirm}
                />
              )}
            />
          </Switch>
        </Container>
      </BrowserRouter>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.js